// extracted by mini-css-extract-plugin
export default {"root":"D2lH_"};